import { sendEvent } from '@/utils'
import { mpx } from '@didi/es-mpx-creator'
import { getEnvInfo, xenv as webxXenv } from '@didi/webx-js'
import { getStorage } from '@/utils/storage'
import { requestCouponApi } from '@/api/coupon'
import { couponStatusConf } from '@/config/coupon'
import { trackEvent } from '@/common/track';

import store from '@/store'

// 处理券数据结构
export const handleCouponData = data => {
  data.banner_coupons = formatData(data?.banner_coupons)
  data.coupons_info = formatData(data?.coupons_info)
  data.stock_coupons_info = formatData(data?.stock_coupons_info)
  data.cyber_set_coupons = formatActivityData(data?.cyber_set_coupons)
  return data
}

// 处理天降数据结构
export const handleFallingData = (list = []) => {
  return list?.map(item => {
    item.displayedInfo = getFallingDisplayedInfo(item)
    return item
  })
}

// 将 pope 数据转为可用的券信息
export const formatData = (list = []) => {
  return list?.map(item => {
    if(item.coupon_type === 'accelerate_package') return item
    item.coupon_info.displayedInfo = getCouponDisplayedInfo(item.coupon_info)
    item.coupon_info.couponStatusInfo = getCouponStatusInfo(item.coupon_info)
    return item
  })
}

// 将活动券处理成正常券格式
const formatActivityData = (list = []) => {
  return list?.map(item => {
    // 自定义活动券的batch_type
    item.batch_type = 222
    item.coupon_info = item
    item.coupon_info.displayedInfo = getCouponDisplayedInfo(item.coupon_info)
    return item
  })
}

// 处理得到前端所需天降券的信息
export const getFallingDisplayedInfo = coupon_info => {
  const productId = Number(coupon_info?.productId)
  switch (Number(coupon_info?.batchType)) {
    case 3:
      return {
        unit: '元',
        amount: coupon_info?.amount / 100,
        product:
          productId === 40734 ? '火车票' : productId === 210 ? '网约车' : '',
      }
    case 100:
      return {
        unit: '折',
        amount: coupon_info?.discount / 10,
        product:
          productId === 40734 ? '火车票' : productId === 210 ? '网约车' : '',
      }
    default:
      return {}
  }
}

// 处理得到前端所需券的信息, 需要传入 coupon_info
export const getCouponDisplayedInfo = coupon_info => {
  switch (Number(coupon_info?.batch_type)) {
    case 3:
      return {
        unit: '元',
        amount: coupon_info?.amount / 100,
        maxAmount: coupon_info?.max_amount
          ? `最高抵${coupon_info.max_amount / 100}元`
          : '无门槛立减券',
        expiredTime: getExpiredTime(coupon_info?.expired_time),
      }
    case 100:
      return {
        unit: '折',
        amount: coupon_info?.discount / 10,
        maxAmount: coupon_info?.max_amount
          ? `最高抵${coupon_info.max_amount / 100}元`
          : '无门槛立减券',
        expiredTime: getExpiredTime(coupon_info?.expired_time),
      }
    case 222:
      // 自定义的活动券
      return {
        unit: '元',
        amount: coupon_info?.amount / 100,
        maxAmount: '最高可领',
        expiredTime: getExpiredTime(coupon_info?.expired_time),
        // activityStatus: activityStatusMap[coupon_info.status]
      }
    default:
      return {}
  }
}

// 获取券状态信息
export const getCouponStatusInfo = coupon_info => {
  // is_appointment_backward_coupon 为 true 代表为预约返程券
  // coupon_id 存在表明券已领
  // has_stock 为 false 代表已抢光
  const type = coupon_info?.is_appointment_backward_coupon
    ? coupon_info?.coupon_id
      ? 'unlocked'
      : 'locked'
    : coupon_info?.coupon_id
    ? 'received'
    : coupon_info?.has_stock
    ? 'unclaimed'
    : 'noStock'
  return {
    text: couponStatusConf?.[type]?.text,
    color: couponStatusConf?.[type]?.color,
    status: couponStatusConf?.[type]?.status,
  }
}

// 返回券的到期时间, 需要传入 expired_time
export const getExpiredTime = (expired_time = '') => {
  return expired_time?.split(' ')?.[0]
    ? '有效期至' + expired_time?.split(' ')?.[0]
    : ''
}

// 助力券状态map
// export const activityStatusMap = {
//   0: '未开始',
//   1: '进行中',
//   3: '已过期',
//   4: '团已完成，可再次开启',
//   5: '团已完成，不可再次开启',
//   6: '团无效，如不符合当前城市'
// }

// 领券接口
export const receiveCoupon = async ({ params, cb }) => {
  try {
    const { xpsid = '', dchn = '', xenv = '' } = store?.state?.common?.xpsmInfo
    const envInfo = await getEnvInfo()

    const envInfoTicket = envInfo?.newTicket
    const userInfoTicket = getStorage?.('userInfo')?.token
    const localToken = mpx.getStorageSync('token')
    // 风控参数
    const envParams = {
      ...envInfo,
      isOpenWeb: false,
      isHitButton: true,
      newTicket: envInfoTicket || userInfoTicket || '',
    }
    if (!localToken) {
      // 埋点 ticket缺失排查
      trackEvent('yks_local_storage_set_or_get_ck', 'yks_local_storage_set_or_get_ck', {
        type: 'request_no_ticket',
        url: '/train-toc/coupon/receive',
        env_from: webxXenv(),
        host: window.location.host,
        env_info_ticket: envInfoTicket ? '1' : '0',
        user_info_ticket: userInfoTicket ? '1' : '0'
      })
    }
    const { code, success, message } = await requestCouponApi({
      dchn,
      xenv,
      xpsid,
      env: envParams,
      ...params,
      ticket: envParams.newTicket
    })
    if (!success) return
    const isNormalCode = Number(code) === 0
    // 展示 toast 信息
    mpx.showToast({
      mask: true,
      title: message,
      icon: isNormalCode ? 'success' : 'error',
    })
    // 领取成功, 执行回调
    if (isNormalCode) cb && cb()
    // 不管成功还是失败都要通知券部分数据更新
    sendEvent('updateCoupon')
  } catch (e) {
    console.log('领券失败了啊！', e)
  }
}
